import axios from "axios";
export default function gateway() {
    // let url = "http://localhost:8000"
    let url = "https://api.busiknow.com"
    return url
}

export const axiosInstance = axios.create({ baseUrl: gateway(), })